import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Flex, Button, Text, InputGroup, Input, InputRightElement, SimpleGrid, Alert, AlertIcon } from '@chakra-ui/react';

import * as FiIcons from 'react-icons/fi';

import Pagination from 'src/components/shared/pagination/Pagination';
import Breadcrumbs from 'src/components/shared/breadcrumbs/Breadcrumbs';
import BooksTable from './Table';
import CreateModal from './actions/CreateModal';
import UpdateModal from './actions/UpdateModal';
import DeleteModal from './actions/DeleteModal';

import { getBooks } from 'src/store/books/booksSlice';

import { Wrapper } from './Styles';

import theme from '../../global/theme';
import ChaptersModal from "./actions/ChaptersModal";

const Books = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const books = useSelector(state => state.books);

  const [page, setPage] = useState(1);
  const [query, setQuery] = useState("");

  const [showCreateBook, setShowCreateBook] = useState(false);
  const [showUpdateBook, setShowUpdateBook] = useState(false);
  const [showDeleteBook, setShowDeleteBook] = useState(false);
  const [showUpdateChapters, setShowUpdateChapters] = useState(false);

  useEffect(() => {
    dispatch(getBooks({ page, query }));
  }, [dispatch, page, query]);


  return (
    <Wrapper>
      <Breadcrumbs
        currentPage={t('pages.books.books')}
        pages={[{ name: `${t('pages.dashboard.dashboard')}`, path: '/' }]}
      />

      {books.error && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          <Text>{books.error}</Text>
        </Alert>
      )}

      <SimpleGrid columns={{ sm: 1, md: 2 }} justifyContent="space-between">
        <Flex marginBottom={8}>
          <Button bg="red.600" textTransform="uppercase"
            fontWeight="bold" fontSize={18} marginInlineEnd={4} color="white" _hover={{ bg: 'red.600' }}
            onClick={() => setShowCreateBook(true)}
          >
            {t('general.create')} +
          </Button>
        </Flex>

        <Flex marginBottom={8} justifyContent="flex-end">
          <InputGroup width="auto">
            <Input auth="auto" type="text" placeholder={t('general.search')}
              bg={theme.light} boxShadow={theme.shadow} color={theme.dark} border="none"
              onChange={(e) => setQuery(e.currentTarget.value)}
            />
            <InputRightElement color={theme.light} children={<FiIcons.FiSearch />} />
          </InputGroup>
        </Flex>
      </SimpleGrid>

      {books.itemsCount > 0 ? (
        <BooksTable
          data={books.data}
          page={page}
          handleUpdate={(el) => setShowUpdateBook(el)}
          handleDelete={(el) => setShowDeleteBook(el)}
          handleChapters={(el) => setShowUpdateChapters(el)}
        />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200} alignItems="center"
          justifyContent="center" borderRadius={16}>
          <Text fontSize={18} textTransform="capitalize" color="gray.300" fontWeight="bold">
            {t('pages.books.no_books')}
          </Text>
        </Flex>
      )}

      <Flex justifyContent="flex-end">
        <Pagination
          page={page}
          itemsCount={books.itemsCount ?? 0}
          onChange={(page) => setPage(page)}
        />
      </Flex>

      {showCreateBook && <CreateModal onClose={() => setShowCreateBook(false)} />}
      {showUpdateBook && <UpdateModal data={showUpdateBook} onClose={() => setShowUpdateBook(false)} />}
      {showDeleteBook && <DeleteModal data={showDeleteBook} onClose={() => setShowDeleteBook(false)} />}
      {showUpdateChapters && <ChaptersModal data={showUpdateChapters} onClose={() => setShowUpdateChapters(false)} />}
    </Wrapper>
  )
}

export default Books